import React, { Component, useState } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom"; // 必要なimport文を追加
import { changeSwModeAction, changeEditerModeAction, changeInPredictAction, changeInExeWaitngAction, finLrnAction, changeWaitngTimeAction } from "../../redux/app/actions";
import { regEditerAction, changeBoringID1Action, changeBoringID2Action } from "../../redux/editer/actions";
import { changeRegionAction, changeCoordAction } from "../../redux/modelArea/actions";
import { openSwAction, openEditerAction, showRegionModelWindowAction, openEstBoringAction, selectWaterShedAction, showTestDataWindowAction, showMeaTimeWindowAction } from "../../redux/ui/actions";
import {
  addDsAction,
  changeDsAction,
  isDrawAction,
  isOkAction,
  changeAnalyRadiusAction,
  changeAnalyBHHeightAction,
  changeAnalyPumpAction,
  changeAnalyWLAction,
  changeMeshRadiusAction,
  changeMeshVertexAction,
  changeMeshSplitAction,
  changeMeshBiasAction,
  changeAnalyTargetAction,
  changePompAmountAction,
  changeWLDAmountAction,
  changeBoringScoreAction,
  changeModelKindAction,
  changeMeshZSplitAction,
  addPompTrAction,
  addScreenTrAction,
  delPompTrAction,
  updatePompTrAction,
  changePompTrSelRowAction,
  delScreenTrAction,
  changePreWLAction,
  changeSameDepthAction,
  changeBorDsAction,
  changeScreenZSplitAction,
  changeMapMeshLayAction,
  changeEquPermCheckAction,
  changeProbThresholdAction,
  changeNewDsAction,
  changeCrossValidAction,
  changeWsArAction,
  changeRegNumAction,
  changeAutoScrChkAction,
  changeConsiderMatAction,
  changeBudgetAction,
  changeUnitCostAction,
  changeMaxScrNumAction,
  changeAnalysisTypeAction,
  changeOptWSAction,
  changeChkKAction,
  changeCpLatAction,
  changeCpLonAction,
} from "../../redux/boring/actions";
import { updateLakeTrAction } from "../../redux/well/actions";
import Select from "../common/Select";
import Sw from "../common/Sw";
import jschardet from "jschardet";

const mapStateToProps = state => {
  return {
    region: state.modelAreaReducer.region,
    coord: state.modelAreaReducer.coord,
    paramRegion: state.paramReducer.region,
    boringDs: state.boringReducer.dataset,
    editerSw: state.uiReducer.editerSw,
    analyRadius: state.boringReducer.analyRadius,
    analyBHHeight: state.boringReducer.analyBHHeight,
    analyPump: state.boringReducer.analyPump,
    analyWL: state.boringReducer.analyWL,
    meshRadius: state.boringReducer.meshRadius,
    meshVertex: state.boringReducer.meshVertex,
    meshSplit: state.boringReducer.meshSplit,
    meshZSplit: state.boringReducer.meshZSplit,
    meshBias: state.boringReducer.meshBias,
    analyTarget: state.boringReducer.analyTarget,
    pompAmount: state.boringReducer.pompAmount,
    wldAmount: state.boringReducer.wldAmount,
    csLineDs: state.csLineReducer.dataset,
    modelKind: state.boringReducer.modelKind,
    pompTrData: state.boringReducer.pompTrData,
    pompTrSelRow: state.boringReducer.pompTrSelRow,
    screenTrData: state.boringReducer.screenTrData,
    screenZSplit: state.boringReducer.screenZSplit,
    mapMeshLay: state.boringReducer.mapMeshLay,
    equPermCheck: state.boringReducer.equPermCheck,
    probThreshold: state.boringReducer.probThreshold,
    crossValid: state.boringReducer.crossValid,
    regMode: state.appReducer.regMode,
    geoDs: state.geoReducer.dataset,
    regNum: state.boringReducer.regNum,
    selRow: state.boringReducer.selRow,
    ds: state.boringReducer.dataset,
    catData: state.boringReducer.catData,
    name: state.boringReducer.name,
    cat: state.boringReducer.cat,
    geoInfo: state.boringReducer.geoInfo,
    coordSystem: state.boringReducer.coordSystem,
    color: state.boringReducer.color,
    tab: state.boringReducer.tab,
    isOk: state.boringReducer.isOk,
    isDraw: state.boringReducer.isDraw,
    file: state.boringReducer.file,
    XAttr: state.boringReducer.XAttr,
    YAttr: state.boringReducer.YAttr,
    depThkRdo: state.boringReducer.depThkRdo,
    ZAttr: state.boringReducer.ZAttr,
    geo: state.boringReducer.geo,
    ID: state.boringReducer.ID,
    GLChk: state.boringReducer.GLChk,
    GL: state.boringReducer.GL,
    WLChk: state.boringReducer.WLChk,
    WL: state.boringReducer.WL,
    headerNum: state.boringReducer.headerNum,
    fieldNameChk: state.boringReducer.fieldNameChk,
    csvData: state.boringReducer.csvData,
    newData: state.boringReducer.newData,
    formData: state.boringReducer.formData,
    userData: state.boringReducer.userData,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    newDs: state.boringReducer.newDs,
    regionModelWindowVisible: state.uiReducer.regionModelWindowVisible,
    id: state.userReducer.id,
    wellsTrData: state.boringReducer.wellsTrData,
    waterShedSelectable: state.uiReducer.waterShedSelectable,
    moduleTable: state.appReducer.moduleTable,
    wsAr: state.boringReducer.wsAr,
    impWS: state.appReducer.impWS,
    userLicense: state.appReducer.userLicense,
    regNum: state.boringReducer.regNum,
    preWL: state.boringReducer.preWL,
    sameDepth: state.boringReducer.sameDepth,
    boringScore: state.boringReducer.boringScore,
    autoScrChk: state.boringReducer.autoScrChk,
    considerMat: state.boringReducer.considerMat,
    budget: state.boringReducer.budget,
    unitCost: state.boringReducer.unitCost,
    maxScrNum: state.boringReducer.maxScrNum,
    testDataWindowVisible: state.uiReducer.testDataWindowVisible,
    wlTrDataTS: state.wellReducer.wlTrData,
    pompTrDataTS: state.wellReducer.pompTrData,
    analyType: state.boringReducer.analyType,
    optWS: state.boringReducer.optWS,
    chkK: state.boringReducer.chkK,
    editerWlMeaData: state.editerReducer.editerWlMeaData,
    editerPompMeaData: state.editerReducer.editerPompMeaData,
    gmUrl: state.appReducer.gmUrl,
    lakeTrData: state.wellReducer.lakeTrData,
    cpLat: state.boringReducer.cpLat,
    cpLon: state.boringReducer.cpLon,
    finLrn: state.appReducer.finLrn,
  };
};
class Main extends Component {
  constructor(props) {
    super(props);
    //地域オプション
    this.regionOpt = [{ val: "0", text: "全表示" }];
    for (let key in this.props.paramRegion) {
      this.regionOpt.push({
        val: key,
        text: key + " : " + this.props.paramRegion[key].name,
      });
    }

    this.closeSw = this.closeSw.bind(this);
    this.changeIdoPram = this.changeIdoPram.bind(this);
    this.checkInput = this.checkInput.bind(this);
    this.props.dispatch(changeEditerModeAction(1));
    this.csIDCoordlst = [];
    this.modelAreaCoord = [];
    this.scrList = [];
    this.boringID1 = this.props.boringID1;
    this.boringID2 = this.props.boringID2;

    this.isStart = false; //描画を開始している場合true
    window.setDrawingFlag(true);
    this.showRegion();
  }

  /*
   * 地域を地図上に表示
   * @since hara 2021-03-23
   */
  showRegion() {
    /*
        const coords = [];
        for (let key in this.props.paramRegion) {
            coords.push(this.props.paramRegion[key].range);
        }
        if (window.existModelArea() || this.props.wellsTrData.length != 0) {
            window.showRegion(coords, 10, false);
        } else {
            window.showRegion(coords, 10, true);
        }
        */

    if (!this.isStart) {
      window.startModelArea(true);
      this.isStart = true;
    }
  }

  waiting = stat => {
    this.props.dispatch(changeInPredictAction(stat));
  };

  /*
   * 推定実行
   * @since kawai 2020-09-09
   */
  async doLearn(pred) {
    const origin = window.location.origin;
    const search = window.location.search;
    /*
     * 入力値確認
     */
    let useChk = true;
    this.props.boringDs.forEach(el => {
      if (el.use) useChk = false;
    });
    if (useChk) {
      alert("推定に使用するボーリングデータセットを1つ以上選択してください。");
      return;
    }
    if (this.props.modelDep < 1 || 1000 < this.props.modelDep) {
      alert("モデル深度は 1~1000 の範囲で設定してください。");
      return;
    }

    /*
     * 推定
     */
    this.waiting(true);

    //チェックされたボーリングの情報を取得
    //boringDsのuseプロパティを使用するよう修正 @since hara 2020-10-08
    let selectedBoring = [];
    this.props.boringDs.forEach(el => {
      if (el.use) {
        selectedBoring.push({
          ID: el["ID"],
          name: el["name"],
        });
      }
    });

    //流域界モデルかつ連動のときは、流域界を内包する範囲を学習領域とする。
    let dr;

    let tmp = window.getmodelAreaCoord();
    dr = [tmp[2], tmp[3], tmp[1], tmp[0]];

    //console.log('===================近傍点井戸ID===================')
    //console.log(window.getModelMarkerNearPoint())
    //サーバへ指定したボーリングを使用して学習を行うように要求
    await fetch(`${origin}/api/user/0/model/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        selectedBoring: selectedBoring,
        //モデル領域機能で選択した領域でモデルを作成する
        range: {
          x1: dr[0],
          x2: dr[1],
          y1: dr[2],
          y2: dr[3],
          rp: this.props.crossValid == 0 ? "none" : window.getModelMarkerNearPoint(),
          mk: this.props.modelKind == undefined ? null : this.props.modelKind,
          wells: this.props.modelKind == 3 ? this.props.wellsTrData : null,
          exe: "learnPredict",
          point: window.getCP(),
        },
      }),
    })
      .then(res => res.json())
      .then(res => {
        console.log("res", res);
        if (res.result == "limit") {
          alert("現在サーバーが混み合っております。時間を空けて再度お試しください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "outside") {
          alert("対応範囲外です。お手数ですが、位置を変更し再実行してください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (JSON.parse(res).result == "timeout") {
          alert("タイムアウトエラーが発生しました。選択しているボーリング数を減らし、再度お試しください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "fetcherror") {
          alert("サーバー内部エラーが発生しました。システム管理者に確認してくだい。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else {
          this.doPredict();

          //予測位置サブウィンドウを開けるようにする
          this.props.dispatch(finLrnAction(true));
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
        this.waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * 予測実行
   * @since kawai 2020-09-15
   */
  async doPredict() {
    const origin = window.location.origin;
    const search = window.location.search;
    fetch(`${origin}/api/0/predict/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        point: window.getCP(),
        type: "well",
        np: window.getModelMarkerNearPoint(),
        sd: this.props.sameDepth,
        msn: this.props.maxScrNum,
        bud: this.props.budget,
        uc: this.props.unitCost,
        geo: this.props.geoDs[0].geo,
        range: {
          x1: window.getmodelAreaCoord()[2],
          x2: window.getmodelAreaCoord()[3],
          y1: window.getmodelAreaCoord()[1],
          y2: window.getmodelAreaCoord()[0],
        },
        exe: "learnPredict",
      }),
    })
      .then(response => response.json())
      .then(results => {
        if (results.result == "error") {
          alert("実行エラー。時間を空けて再度お試しください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (results.result == "timeout") {
          console.log("タイムアウトエラー");
          alert("タイムアウトエラーが発生しました。選択しているボーリング数を減らし、再度お試しください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (results.result == "limit") {
          alert("予測実行回数の上限に達したため、実行できません。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
          return;
        } else {
          this.regAnalysisBoring(results.data);
          //this.props.dispatch(changeBoringScoreAction(results.score[1] + '%'));
          window.setPredAcc(results.score[1] + "%");
          window.setAnalyAcc(results.score[4]);
          document.getElementById("BoringPredAcc").value = results.score[1] + "%";
          document.getElementById("AnalyAcc").value = results.score[4];
          //if (this.props.sameDepth == 1) {
          console.log("最近傍:" + results.score[0] + "\nTOP1:" + results.score[1] + "\nTOP3:" + results.score[2] + "\nALL :" + results.score[3]);
          //}
          //console.log(results.score)
          if (results.score[5] != "NOLAKE") {
            window.setAnalyAcc("不明");
            document.getElementById("AnalyAcc").value = "不明";
            alert("影響圏半径に" + results.score[5] + "が含まれます。GM-WELLでは湖沼を解析条件として考慮していないため、解析精度が著しく低下する可能性がございます。");
          }
          if (results.screen_exists == 0 && this.props.sameDepth == 0 && this.props.maxScrNum != 0) {
            alert("スクリーンを設定可能な地層がありません。この位置でGM-WELLを使用するには地質情報からスクリーン設定を行う地質を追加する必要があります。");
          }
          console.log(results.screen_exists);
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
        this.waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * 実行可否を確認
   * @since ando 2025-07-31
   */
  async doCheckExe() {
    const origin = window.location.origin;
    const search = window.location.search;

    try {
      const res = await fetch(`${origin}/api/0/checkExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "estBoring",
        }),
      });

      const json = await res.json();
      console.log("res", json);

      if (json.result === "OK") {
        return true; // 処理可能
      } else {
        this.props.dispatch(changeWaitngTimeAction(json.waiting_time)); // GUI表示
        this.props.dispatch(changeInExeWaitngAction(true)); // GUI表示
        return false; // 待機状態
      }
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      return false; // エラー時も止める
    }
  }

  /*
   * ポンプ変更
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  changeIdoPram(e, id) {
    console.log(id);
    switch (id) {
      case "cv":
        if (this.props.crossValid == 0) {
          return this.props.dispatch(changeCrossValidAction(1));
        } else {
          return this.props.dispatch(changeCrossValidAction(0));
        }
      case "sd":
        if (this.props.sameDepth == 0) {
          return this.props.dispatch(changeSameDepthAction(1));
        } else {
          return this.props.dispatch(changeSameDepthAction(0));
        }
      case "msn":
        return this.props.dispatch(changeMaxScrNumAction(e.target.value));
      case "bud":
        return this.props.dispatch(changeBudgetAction(e.target.value));
      case "uc":
        return this.props.dispatch(changeUnitCostAction(e.target.value));
      case "lat":
        //井戸予測が完了していた場合、削除して良いかのアラートを出力する
        /*
        if (this.props.finLrn) {
          let answer = window.confirm("学習領域を再設定する場合、学習結果・予測位置・予測結果の\nデータが削除されます。よろしいですか。");
          if (answer) {
            window.removeModelArea();
            window.removeModelMarker();
            window.setSelBoringNum(0);
            this.props.dispatch(finLrnAction(false));
            window.changeCPLat(e.target.value);
            this.props.dispatch(changeCpLonAction(window.formatNumber(Number(window.getCP()[0]))));
            return this.props.dispatch(changeCpLatAction(e.target.value));
          } else {
            return;
          }
        } else {
          */
        window.changeCPLat(e.target.value);
        this.props.dispatch(changeCpLonAction(window.formatNumber(Number(window.getCP()[0]))));
        return this.props.dispatch(changeCpLatAction(e.target.value));

      case "lon":
        //井戸予測が完了していた場合、削除して良いかのアラートを出力する
        /*
        if (this.props.finLrn) {
          let answer = window.confirm("井戸位置を再設定する場合、学習結果・予測位置・予測結果の\nデータが削除されます。よろしいですか。");
          if (answer) {
            window.removeModelArea();
            window.removeModelMarker();
            window.setSelBoringNum(0);
            this.props.dispatch(finLrnAction(false));
            window.changeCPLon(e.target.value);
            this.props.dispatch(changeCpLatAction(Number(window.getCP()[1]).toFixed(5)));
            return this.props.dispatch(changeCpLonAction(e.target.value));
          } else {
            return;
          }
        } else {
        */
        window.changeCPLon(e.target.value);
        this.props.dispatch(changeCpLatAction(window.formatNumber(Number(window.getCP()[1]))));
        return this.props.dispatch(changeCpLonAction(e.target.value));
    }
  }

  /*
   * ポンプ変更
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkIdoPram(e, id) {
    console.log(id);
    let initLonLat = [140, 40];
    switch (id) {
      case "bud": //予算
        if (this.checkInput(e.target.value, "予算（円）", 100000, 10000000)) {
          return this.props.dispatch(changeBudgetAction(e.target.value));
        } else {
          return this.props.dispatch(changeBudgetAction(1000000));
        }
      case "uc": //メートル単価
        if (this.checkInput(e.target.value, "メートル単価（円）", 5000, 100000)) {
          return this.props.dispatch(changeUnitCostAction(e.target.value));
        } else {
          return this.props.dispatch(changeUnitCostAction(10000));
        }
      case "lat":
        if (this.checkInput(e.target.value, "緯度", 20, 46)) {
          if (e.target.value === "") return;

          const numLat = Number(e.target.value);
          if (isNaN(numLat)) return;

          this.props.dispatch(changeCpLatAction(window.formatNumber(numLat)));
          //描画ポイントを更新する
          window.drawModelMarker([Number(this.props.cpLon), Number(this.props.cpLat)], true);
          break;
        } else {
          window.changeCPLat(initLonLat[1]);
          window.drawModelMarker([Number(this.props.cpLon), initLonLat[1]], true);
          return this.props.dispatch(changeCpLatAction(initLonLat[1]));
        }

      case "lon":
        if (this.checkInput(e.target.value, "経度", 122, 154)) {
          if (e.target.value === "") return;

          const numLon = Number(e.target.value);
          if (isNaN(numLon)) return;

          this.props.dispatch(changeCpLonAction(window.formatNumber(numLon)));
          //描画ポイントを更新する
          window.drawModelMarker([Number(this.props.cpLon), Number(this.props.cpLat)], true);
          break;
        } else {
          window.changeCPLon(initLonLat[0]);
          window.drawModelMarker([initLonLat[0], Number(this.props.cpLat)], true);
          return this.props.dispatch(changeCpLonAction(initLonLat[0]));
        }
    }
  }

  /*
   * 表示/非表示を切り替える
   * @since ando 2023-08-08
   */
  checkCrossValid() {
    if (this.props.crossValid == 0) {
      return false;
    } else {
      return true;
    }
  }

  /*
   * 表示/非表示を切り替える
   * @since ando 2023-08-08
   */
  checkSameDepth() {
    if (this.props.sameDepth == 0) {
      return false;
    } else {
      return true;
    }
  }

  /*
   * 入力値チェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkInput(v, str, min, max, isInteger) {
    if (isNaN(v)) {
      alert(str + "は半角数字を入力してください。");
      return false;
    } else if (isInteger) {
      if (!Number.isInteger(Number(v))) {
        alert(str + "は整数を入力してください。");
        return false;
      } else if (v.indexOf(".") != -1) {
        alert(str + "は小数点を含む値を入力できません。");
        return false;
      } else if (!(v >= min && v <= max)) {
        alert(str + "は" + min + "以上、" + max + "以下で入力してください。");
        return false;
      } else {
        return true;
      }
    } else if (!(v >= min && v <= max)) {
      alert(str + "は" + min + "以上、" + max + "以下で入力してください。");
      return false;
    } else {
      return true;
    }
  }

  /*
   * ボーリング数チェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkBoringNum() {
    let num = window.cntAreaBoring(window.getmodelAreaCoord()[0], window.getmodelAreaCoord()[1], window.getmodelAreaCoord()[2], window.getmodelAreaCoord()[3]);
    //console.log(num)
    //最近傍井戸のチェックが入っていた場合、自身は除くため2本以上必要
    if (this.props.crossValid == 1) {
      if (num < 2) {
        alert("最近傍井戸を除外している場合、学習領域内に2本以上のボーリングが必要です。");
        return false;
      } else {
        return true;
      }
    } else {
      if (num < 1) {
        alert("学習領域が存在しないか学習領域内のボーリングが不足しています。");
        return false;
      } else {
        return true;
      }
    }
  }

  /*
   * パラメータチェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkParam() {
    if (isNaN(this.props.meshRadius)) {
      alert("モデル半径を入力してください。");
      return false;
    } else if (isNaN(this.props.meshVertex)) {
      alert("周方向分割数を入力してください。");
      return false;
    } else if (isNaN(this.props.meshSplit)) {
      alert("平面分割数を入力してください。");
      return false;
    } else if (isNaN(this.props.meshBias)) {
      alert("バイアスを入力してください");
      return false;
    } else if (isNaN(this.props.wldAmount) && isNaN(this.props.pompAmount)) {
      alert("目標量を入力してください");
      return false;
    } else {
      return true;
    }
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    console.log(this.props.regionModelWindowVisible);
    if (window.existModelArea()) {
      //入力データをチェック
      let keys = 0;

      //クリック位置からエリアを特定
      for (let key in this.props.paramRegion) {
        const coord = this.props.paramRegion[key].range;
        if (coord["x1"] < window.getCP()[0] && coord["y1"] < window.getCP()[1] && coord["x2"] > window.getCP()[0] && coord["y2"] > window.getCP()[1]) {
          keys = key;
        }
      }

      //クリック位置に含まれる流域界を選択する。
      window.deleteSelectedWaterShed();
      window.getCPWaterShed(window.getCP());
      this.props.dispatch(updateLakeTrAction(window.syncLakeTrData(this.props.lakeTrData, window.getWsLakes())));

      this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
      this.props.dispatch(openSwAction(null));
      this.props.dispatch(changeSwModeAction(0));
      this.props.dispatch(changeEditerModeAction(0));
      this.props.dispatch(openEstBoringAction(null));
      this.props.dispatch(showMeaTimeWindowAction(false));
      //window.changeShowData("ws", false);
      window.endSelectWaterShed();
      window.endMultiWells();
      window.endModelArea(false);
      window.setBoringID();
    } else {
      this.props.dispatch(openSwAction(null));
      this.props.dispatch(changeSwModeAction(0));
      this.props.dispatch(changeEditerModeAction(0));
      this.props.dispatch(openEstBoringAction(null));
      this.props.dispatch(showMeaTimeWindowAction(false));
      //window.changeShowData("ws", false);
      window.endSelectWaterShed();
      window.endMultiWells();
      window.endModelArea(false);
    }
    window.removeRegionLay();
    window.setDrawingFlag(false);
    this.props.dispatch(changePompTrSelRowAction(null));
  }

  /*
   * 推定ボーリング登録
   * @since ando 2023-08-19
   */
  regAnalysisBoring(result) {
    this.props.dispatch(openEditerAction(null));
    console.log(result);
    let action;
    if (this.props.preWL == null) {
      //新規の場合
      action = addDsAction;
      this.props.dispatch(changeRegNumAction(this.props.regNum + 1));
      this.props.dispatch(changePreWLAction(this.props.regNum));
      console.log("addDsAction");
    } else {
      action = changeDsAction;
      console.log("changeDsAction");
    }
    const ID = this.props.preWL;
    let vis = true;
    let use = true;
    let zIndex = 0;
    let formData = this.props.formData;
    this.props.dispatch(
      action({
        ID: ID,
        name: "Analysis",
        cat: parseInt(this.props.cat),
        geoInfo: this.props.geoInfo,
        coordSystem: this.props.coordSystem,
        color: this.props.color,
        vis: vis,
        use: use,
        zIndex: zIndex,
        data: result,
        file: this.props.file,
        XAttr: result[0]["lon"],
        YAttr: result[0]["lat"],
        depThkRdo: this.props.depThkRdo,
        ZAttr: this.props.ZAttr,
        geo: [],
        pID: this.props.ID,
        GLChk: this.props.GLChk,
        GL: this.props.GL,
        WLChk: this.props.WLChk,
        WL: this.props.WL,
        headerNum: this.props.headerNum,
        fieldNameChk: this.props.fieldNameChk,
        csvData: this.props.csvData,
        newData: this.props.newData,
        formData: formData,
        userData: this.props.userData,
      })
    );

    //this.props.dispatch(isOkAction(true));
    this.props.dispatch(isDrawAction(true));
    window.setAP([result[0]["lon"], result[0]["lat"]]);
    if (this.props.isDraw) {
      let ds;
      ds = this.props.ds.slice(ID - 1)[0]; //最後のデータセットを取得
      window.delUserPointLay();
      window.createBoringLay(result, ds.color, ds.ID, ds.vis, ds.zIndex);
      this.props.dispatch(isDrawAction(false));
    }
    const id = ID - 1 + "_0";
    const idD = id.split("_");
    this.boringID1 = idD[0];
    this.boringID2 = idD[1];
    this.props.dispatch(changeBoringID1Action(this.boringID1));
    this.props.dispatch(changeBoringID2Action(this.boringID2));

    //検証としてオブジェクトの比較を行う
    //console.log('-----compObj')
    //console.log(window.compObj(this.props.boringDs,JSON.parse(JSON.stringify(this.props.boringDs))))

    //boringDsをNewDsにコピーする（Editerで使用）
    this.props.dispatch(changeNewDsAction(this.props.boringDs));
    //this.props.dispatch(changeNewDsAction(JSON.parse(JSON.stringify(this.props.boringDs))));
    this.props.dispatch(openEditerAction(id));
    window.changeBoringIdx(ID, ID);
  }

  /*
   * GM-WELL連動
   * @since ando 2023-08-07
   */
  async doLearnPred() {
    //ユーザーの通信状況をチェック
    await this.doCheckExe();
    if (await window.checkSpeed("通信速度が低速です。アプリケーションの処理に時間を要する場合がございます。", 2000)) {
      //入力データをチェック
      //学習領域内のボーリング数をチェック

      if (this.checkParam()) {
        if (this.checkBoringNum()) {
          if (window.existModelArea()) {
            this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
            //this.props.dispatch(changeEditerModeAction(0));
            await this.doLearn(true);
          } else {
            alert("学習領域を作成してください。");
          }
        } else {
        }
      }
    }
  }

  componentDidMount() {
    // ウィンドウが開かれたときにイベントリスナーを追加
    //window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // ウィンドウが閉じられたときにイベントリスナーを削除
    //window.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    return (
      <div>
        <Sw title="柱状図予測" focusName="estB">
          {/*無料ユーザー*/}
          {this.props.userLicense === 2 && (
            <div>
              <div>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸座標</legend>
                  <div>
                    <label className="wl_label">緯度(度)：</label>
                    <input className="textSSR" id="Lat" type="text" value={this.props.cpLat} onChange={e => this.changeIdoPram(e, "lat")} onBlur={e => this.checkIdoPram(e, "lat")} />
                    <label className="wl_label">経度(度)：</label>
                    <input className="textSSR" id="Lon" type="text" value={this.props.cpLon} onChange={e => this.changeIdoPram(e, "lon")} onBlur={e => this.checkIdoPram(e, "lon")} />
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend>工事予算</legend>

                  <div className="l-row">
                    <div className="l-row,">
                      <label className="wl_labelM">予算（円）：</label>
                      <input className="textSSR" type="text" value={this.props.budget} onChange={e => this.changeIdoPram(e, "bud")} onBlur={e => this.checkIdoPram(e, "bud")} />
                    </div>

                    <div className="l-row">
                      <label className="bud_label">メートル単価（円）：</label>
                      <input className="textSSR" type="text" value={this.props.unitCost} onChange={e => this.changeIdoPram(e, "uc")} onBlur={e => this.checkIdoPram(e, "uc")} />
                    </div>
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸予測</legend>
                  <div className="l-right">
                    <label className="marginT">選択ボーリング数：</label>
                    <input className="textSSAS" id="BoringNum" type="text" disabled="disabled" value={window.getSelBoringNum()} />
                    {this.props.userLicense == 0 && (
                      <legend className="tsSA">
                        <input type="checkbox" id="sameDepthCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "sd")} checked={this.checkSameDepth()} />
                        <label htmlFor="sameDepthCheck"></label>&nbsp;同深度
                      </legend>
                    )}
                    <legend className="tsLgd">
                      <input type="checkbox" id="selfLearnCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "cv")} checked={this.checkCrossValid()} />
                      <label htmlFor="selfLearnCheck"></label>
                      &nbsp;最近傍井戸除外
                    </legend>
                    <button className="plBtn marginB" onClick={this.doLearnPred.bind(this)}>
                      予測
                    </button>
                  </div>
                  <fieldset className="Unit l-mtSSS">
                    {/*
                    <div>
                      <label className="wl_labelL">最近傍揚水データとの距離：</label>
                      <input className="textSSA" id="MeaDataDist" type="text" disabled="disabled" value={window.getNearestPompData()} />
                    </div>
                    */}
                    <div>
                      <label className="wl_labelL">　　　ボーリング予測精度：</label>
                      <input className="textSSAS" id="BoringPredAcc" type="text" disabled="disabled" value={window.getPredAcc()} />
                      <label className="wl_label">解析予測精度：</label>
                      <input className="textSSAS" id="AnalyAcc" type="text" disabled="disabled" value={window.getAnalyAcc()} />
                      <p>
                        ※予測精度は実測値から予測した目安であり、実際の精度を保証するものではありません。
                        <br />
                        ※予測深度は周囲のボーリング深度、工事予算を目安に設定されます。
                        <br />
                      </p>
                    </div>
                  </fieldset>
                </fieldset>
              </div>
              <div className="l-right l-mtS ">
                <button className="cBtn" onClick={this.closeSw}>
                  閉じる
                </button>
              </div>
            </div>
          )}
          {/*標準ユーザー*/}
          {this.props.userLicense === 3 && (
            <div>
              <div>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸座標</legend>
                  <div>
                    <label className="wl_label">緯度(度)：</label>
                    <input className="textSSR" id="Lat" type="text" value={this.props.cpLat} onChange={e => this.changeIdoPram(e, "lat")} onBlur={e => this.checkIdoPram(e, "lat")} />
                    <label className="wl_label">経度(度)：</label>
                    <input className="textSSR" id="Lon" type="text" value={this.props.cpLon} onChange={e => this.changeIdoPram(e, "lon")} onBlur={e => this.checkIdoPram(e, "lon")} />
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend>工事予算</legend>

                  <div className="l-row">
                    <div className="l-row,">
                      <label className="wl_labelM">予算（円）：</label>
                      <input className="textSSR" type="text" value={this.props.budget} onChange={e => this.changeIdoPram(e, "bud")} onBlur={e => this.checkIdoPram(e, "bud")} />
                    </div>

                    <div className="l-row">
                      <label className="bud_label">メートル単価（円）：</label>
                      <input className="textSSR" type="text" value={this.props.unitCost} onChange={e => this.changeIdoPram(e, "uc")} onBlur={e => this.checkIdoPram(e, "uc")} />
                    </div>
                  </div>

                  <div className="l-row">
                    <label className="wl_labelM">スクリーン最大設定数：</label>
                    <select className="selectSM" value={this.props.maxScrNum} onChange={e => this.changeIdoPram(e, "msn")}>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                    </select>
                    <p>
                      <br />
                    </p>
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸予測</legend>
                  <div className="l-right">
                    <label className="marginT">選択ボーリング数：</label>
                    <input className="textSSAS" id="BoringNum" type="text" disabled="disabled" value={window.getSelBoringNum()} />
                    {this.props.userLicense == 0 && (
                      <legend className="tsSA">
                        <input type="checkbox" id="sameDepthCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "sd")} checked={this.checkSameDepth()} />
                        <label htmlFor="sameDepthCheck"></label>&nbsp;同深度
                      </legend>
                    )}
                    <legend className="tsLgd">
                      <input type="checkbox" id="selfLearnCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "cv")} checked={this.checkCrossValid()} />
                      <label htmlFor="selfLearnCheck"></label>
                      &nbsp;最近傍井戸除外
                    </legend>
                    <button className="plBtn marginB" onClick={this.doLearnPred.bind(this)}>
                      予測
                    </button>
                  </div>
                  <fieldset className="Unit l-mtSSS">
                    {/*
                    <div>
                      <label className="wl_labelL">最近傍揚水データとの距離：</label>
                      <input className="textSSA" id="MeaDataDist" type="text" disabled="disabled" value={window.getNearestPompData()} />
                    </div>
                    */}
                    <div>
                      <label className="wl_labelL">　　　ボーリング予測精度：</label>
                      <input className="textSSAS" id="BoringPredAcc" type="text" disabled="disabled" value={window.getPredAcc()} />
                      <label className="wl_label">解析予測精度：</label>
                      <input className="textSSAS" id="AnalyAcc" type="text" disabled="disabled" value={window.getAnalyAcc()} />
                      <p>
                        ※予測精度は実測値から予測した目安であり、実際の精度を保証するものではありません。
                        <br />
                        ※予測深度は周囲のボーリング深度、工事予算を目安に設定されます。
                        <br />
                      </p>
                    </div>
                  </fieldset>
                </fieldset>
              </div>
              <div className="l-right l-mtS ">
                <button className="cBtn" onClick={this.closeSw}>
                  閉じる
                </button>
              </div>
            </div>
          )}
          {/*オプションユーザー*/}
          {this.props.userLicense === 4 && (
            <div>
              <div>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸座標</legend>
                  <div>
                    <label className="wl_label">緯度(度)：</label>
                    <input className="textSSR" id="Lat" type="text" value={this.props.cpLat} onChange={e => this.changeIdoPram(e, "lat")} onBlur={e => this.checkIdoPram(e, "lat")} />
                    <label className="wl_label">経度(度)：</label>
                    <input className="textSSR" id="Lon" type="text" value={this.props.cpLon} onChange={e => this.changeIdoPram(e, "lon")} onBlur={e => this.checkIdoPram(e, "lon")} />
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend>工事予算</legend>

                  <div className="l-row">
                    <div className="l-row,">
                      <label className="wl_labelM">予算（円）：</label>
                      <input className="textSSR" type="text" value={this.props.budget} onChange={e => this.changeIdoPram(e, "bud")} onBlur={e => this.checkIdoPram(e, "bud")} />
                    </div>

                    <div className="l-row">
                      <label className="bud_label">メートル単価（円）：</label>
                      <input className="textSSR" type="text" value={this.props.unitCost} onChange={e => this.changeIdoPram(e, "uc")} onBlur={e => this.checkIdoPram(e, "uc")} />
                    </div>
                  </div>

                  <div className="l-row">
                    <label className="wl_labelM">スクリーン最大設定数：</label>
                    <select className="selectSM" value={this.props.maxScrNum} onChange={e => this.changeIdoPram(e, "msn")}>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                    </select>
                    <p>
                      <br />
                    </p>
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸予測</legend>
                  <div className="l-right">
                    <label className="marginT">選択ボーリング数：</label>
                    <input className="textSSAS" id="BoringNum" type="text" disabled="disabled" value={window.getSelBoringNum()} />
                    {this.props.userLicense == 0 && (
                      <legend className="tsSA">
                        <input type="checkbox" id="sameDepthCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "sd")} checked={this.checkSameDepth()} />
                        <label htmlFor="sameDepthCheck"></label>&nbsp;同深度
                      </legend>
                    )}
                    <legend className="tsLgd">
                      <input type="checkbox" id="selfLearnCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "cv")} checked={this.checkCrossValid()} />
                      <label htmlFor="selfLearnCheck"></label>
                      &nbsp;最近傍井戸除外
                    </legend>
                    <button className="plBtn marginB" onClick={this.doLearnPred.bind(this)}>
                      予測
                    </button>
                  </div>
                  <fieldset className="Unit l-mtSSS">
                    {/*
                    <div>
                      <label className="wl_labelL">最近傍揚水データとの距離：</label>
                      <input className="textSSA" id="MeaDataDist" type="text" disabled="disabled" value={window.getNearestPompData()} />
                    </div>
                    */}
                    <div>
                      <label className="wl_labelL">　　　ボーリング予測精度：</label>
                      <input className="textSSAS" id="BoringPredAcc" type="text" disabled="disabled" value={window.getPredAcc()} />
                      <label className="wl_label">解析予測精度：</label>
                      <input className="textSSAS" id="AnalyAcc" type="text" disabled="disabled" value={window.getAnalyAcc()} />
                      <p>
                        ※予測精度は実測値から予測した目安であり、実際の精度を保証するものではありません。
                        <br />
                        ※予測深度は周囲のボーリング深度、工事予算を目安に設定されます。
                        <br />
                      </p>
                    </div>
                  </fieldset>
                </fieldset>
              </div>
              <div className="l-right l-mtS ">
                <button className="cBtn" onClick={this.closeSw}>
                  閉じる
                </button>
              </div>
            </div>
          )}
          {/*オプションユーザー*/}
          {this.props.userLicense === 0 && (
            <div>
              <div>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸座標</legend>
                  <div>
                    {/*
                    <label className="wl_label">緯度(度)：</label>
                    <input className="textSSR" id="Lat" type="text" value={window.getCP()[1].toFixed(5)} />
                    <label className="wl_label">経度(度)：</label>
                    <input className="textSSR" id="Lon" type="text" value={window.getCP()[0].toFixed(5)} />
          */}
                    <label className="wl_label">緯度(度)：</label>
                    <input className="textSSR" id="Lat" type="text" value={this.props.cpLat} onChange={e => this.changeIdoPram(e, "lat")} onBlur={e => this.checkIdoPram(e, "lat")} />
                    <label className="wl_label">経度(度)：</label>
                    <input className="textSSR" id="Lon" type="text" value={this.props.cpLon} onChange={e => this.changeIdoPram(e, "lon")} onBlur={e => this.checkIdoPram(e, "lon")} />
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend>工事予算</legend>

                  <div className="l-row">
                    <div className="l-row,">
                      <label className="wl_labelM">予算（円）：</label>
                      <input className="textSSR" type="text" value={this.props.budget} onChange={e => this.changeIdoPram(e, "bud")} onBlur={e => this.checkIdoPram(e, "bud")} />
                    </div>

                    <div className="l-row">
                      <label className="bud_label">メートル単価（円）：</label>
                      <input className="textSSR" type="text" value={this.props.unitCost} onChange={e => this.changeIdoPram(e, "uc")} onBlur={e => this.checkIdoPram(e, "uc")} />
                    </div>
                  </div>

                  <div className="l-row">
                    <label className="wl_labelM">スクリーン最大設定数：</label>
                    <select className="selectSM" value={this.props.maxScrNum} onChange={e => this.changeIdoPram(e, "msn")}>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                    </select>
                    <p>
                      <br />
                    </p>
                  </div>
                </fieldset>
                <fieldset className="Unit l-mtSSS">
                  <legend> 井戸予測</legend>
                  <div className="l-right">
                    <label className="marginT">選択ボーリング数：</label>
                    <input className="textSSAS" id="BoringNum" type="text" disabled="disabled" value={window.getSelBoringNum()} />
                    {this.props.userLicense == 0 && (
                      <legend className="tsSA">
                        <input type="checkbox" id="sameDepthCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "sd")} checked={this.checkSameDepth()} />
                        <label htmlFor="sameDepthCheck"></label>&nbsp;同深度
                      </legend>
                    )}
                    <legend className="tsLgd">
                      <input type="checkbox" id="selfLearnCheck" name="1" className="check" onChange={e => this.changeIdoPram(1, "cv")} checked={this.checkCrossValid()} />
                      <label htmlFor="selfLearnCheck"></label>
                      &nbsp;最近傍井戸除外
                    </legend>
                    <button className="plBtn marginB" onClick={this.doLearnPred.bind(this)}>
                      予測
                    </button>
                  </div>
                  <fieldset className="Unit l-mtSSS">
                    {/*
                    <div>
                      <label className="wl_labelL">最近傍揚水データとの距離：</label>
                      <input className="textSSA" id="MeaDataDist" type="text" disabled="disabled" value={window.getNearestPompData()} />
                    </div>
                    */}
                    <div>
                      <label className="wl_labelL">　　　ボーリング予測精度：</label>
                      <input className="textSSAS" id="BoringPredAcc" type="text" disabled="disabled" value={window.getPredAcc()} />
                      <label className="wl_label">解析予測精度：</label>
                      <input className="textSSAS" id="AnalyAcc" type="text" disabled="disabled" value={window.getAnalyAcc()} />
                      <p>
                        ※予測精度は実測値から予測した目安であり、実際の精度を保証するものではありません。
                        <br />
                        ※予測深度は周囲のボーリング深度、工事予算を目安に設定されます。
                        <br />
                      </p>
                    </div>
                  </fieldset>
                </fieldset>
              </div>
              <div className="l-right l-mtS ">
                <button className="cBtn" onClick={this.closeSw}>
                  閉じる
                </button>
              </div>
            </div>
          )}
        </Sw>
      </div>
    );
  }
}

/*
 * エクスポートテスト用
 * @since ando 2023-09-08
 */
export function exportTest(str) {
  console.log(this.props.analyPump + str);
}

export default connect(mapStateToProps)(Main);
